// extracted by mini-css-extract-plugin
module.exports = {"popup_panel":"FJFade_popup_panel__3SC1n","fade_slider":"FJFade_fade_slider__iF9Pi"};